




















































































import Vue, { VueConstructor } from 'vue'
import BalanceCard from '@/components/BalanceCard.vue'
import AccountMixin from '../../../../../mixins/accountMixin'
import { mapGetters } from 'vuex'
import { CreditLineProvisionService } from '@/api/services/credit-line-provision'

interface Disbursment {
  transactionNumber: number
  sfd: string
  creditLine: string
  initiatorName: string
  dateTime: string
  amount: number
  mobileOperator: string
}

interface ComponentData {
  states: Record<string, object>
  columns: Record<string, string | boolean>[]
  items: any[]
  total: number | undefined
  pagination: {
    page: number
    perPage: number
  }
}

export default (Vue as VueConstructor<
  Vue & InstanceType<typeof AccountMixin>
>).extend({
  components: {
    BalanceCard
  },

  data() {
    return {
      states: {
        created: { label: 'Nouveau', color: 'blue-600', bg: 'blue-200' },
        pending: { label: 'En attente', color: 'yellow-600', bg: 'yellow-200' },
        successeed: { label: 'Succès', color: 'green-100', bg: 'green-300' },
        failed: { label: 'Échec', color: 'red-100', bg: 'red-300' }
      },
      columns: [
        // {
        //   label: 'N° Transaction',
        //   field: '_iteration',
        //   searchable: true
        // },
        {
          label: 'SFD',
          field: 'organization.name',
          searchable: true
        },
        {
          label: 'Ligne de crédit',
          field: 'creditLine.name',
          searchable: true
        },
        {
          label: 'Nom Initiateur',
          field: 'createdBy.fullname'
        },
        {
          label: 'Date/Heure',
          field: 'createdAt'
        },
        {
          label: 'Montant',
          field: 'amount',
          searchable: true
        },
        {
          label: 'Opérateur Mobile',
          field: 'otm',
          align: 'center',
          searchable: true
        },
        {
          label: 'Status',
          field: 'state',
          align: 'center'
        },
        {
          label: 'Actions',
          field: '_actions',
          align: 'center'
        }
      ],
      items: [],
      total: 0,
      pagination: {
        page: 1,
        perPage: 10
      }
    }
  },

  mixins: [AccountMixin],

  computed: {
    ...mapGetters('product', ['getCurrentProduct']),

    // items() {
    //   return this.data
    //   // return CreditLineProvision.query()
    //   //   .with(['createdBy', 'creditLine', 'organization', 'transaction'])
    //   //   .where('state', (state: string) => state !== 'canceled')
    //   //   .get()
    // },

    mtnAmount(this: any) {
      return this.items
        .filter((item: any) => item.otm === 'mtn')
        .reduce((total: number, item: any) => total + item.amount, 0)
    },

    moovAmount(this: any) {
      return this.items
        .filter((item: any) => item.otm === 'moov')
        .reduce((total: number, item: any) => total + item.amount, 0)
    },

    totalAmount(this: any) {
      return this.mtnAmount + this.moovAmount
    },
    moovBalance(this: any): number {
      return this.soldeRembourssementMoov
    },
    mtnBalance(this: any): number {
      return this.soldeRembourssementMtn
    },
    totalBalance(this: any): number {
      return this.moovBalance + this.mtnBalance
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    onSeeDetails(id: string) {
      this.$router.push({
        name: 'disbursments.details',
        params: { disbursmentId: id }
      })
    },
    async fetchData() {
      const response = await CreditLineProvisionService.findAll(
        this.$route.params.productId,
        this.pagination,
        undefined,
        ['organization', 'creditLine', 'createdBy']
      )
      this.items = response.result
      this.total = response.count
    },
    onPrev() {
      if (this.pagination.page > 1) {
        this.pagination.page--
        this.fetchData()
      }
    },
    onNext() {
      if (
        this.total &&
        this.pagination.page * this.pagination.perPage < this.total
      ) {
        this.pagination.page++
        this.fetchData()
      }
    }
  }
})
